module.exports = __webpack_public_path__ + "img/model09.9a562043.png";